export default "__VITE_ASSET__CkFkw7$V__"